/**
 * JSON subtasks reference image filenames that live in `src/assets/images/`.
 * Those files are not served at a public URL unless imported; this map wires
 * each bundled asset URL by basename. Unknown names fall back to `/data/images/`.
 */
const bundled = import.meta.glob<string>('../assets/images/*.{png,jpg,jpeg,svg,webp,gif}', {
  eager: true,
  import: 'default',
});

const urlByBasename = new Map<string, string>();
for (const path of Object.keys(bundled)) {
  const base = path.split('/').pop();
  if (base) urlByBasename.set(base, bundled[path] as string);
}

export function resolveTasklistSubtaskImageSrc(filename: string | null | undefined): string | undefined {
  if (!filename || !filename.trim()) return undefined;
  const trimmed = filename.trim();
  const fromBundle = urlByBasename.get(trimmed);
  if (fromBundle) return fromBundle;
  return `/data/images/${encodeURIComponent(trimmed)}`;
}
